module.exports = __webpack_public_path__ + "html/project-access_331870c9e661da6fd360784c9678715c.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/project-access.html
// module id = rNCV
// module chunks = 55